import { Note } from './models';

export interface NoteState {
  notes: Note[];
  selectedNote: Note | null;
  totalCount: number;
  loading: boolean;
  error: string | null;
}

export const initialState: NoteState = {
  notes: [],
  selectedNote: null,
  totalCount: 0,
  loading: false,
  error: null,
};
